import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IonImg, IonLabel } from '@ionic/angular/standalone';
import { AvatarOrInitialsComponent } from '../../avatar-or-initials/avatar-or-initials.component';
import { MonetaryValueComponent } from '../../monetary-value/monetary-value.component';
import { SlipComponentStatusComponent } from '../slip-component-status/slip-component-status.component';
import { SlipTypeComponent } from '../slip-type/slip-type.component';
import { SlipDetails, SlipType } from '../student-slip-modal.store';
import { ExpandableParaComponent } from './expandable-para/expandable-para.component';

@Component({
  selector: 'app-student-slip-details',
  templateUrl: './student-slip-details.component.html',
  styleUrls: ['./student-slip-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AvatarOrInitialsComponent,
    NgClass,
    SlipTypeComponent,
    SlipComponentStatusComponent,
    MonetaryValueComponent,
    ExpandableParaComponent,
    DatePipe,
    IonLabel,
    IonImg
  ]
})
export class StudentSlipDetailsComponent {
  private modelBacking: SlipDetails;
  @Input()
  public get model(): SlipDetails {
    return this.modelBacking;
  }
  public set model(value: SlipDetails) {
    this.modelBacking = value;
    this.slipType = this.getSlipType(value.type);
    this.slipIcon = this.getSlipIcon(value.type);
  }

  slipIcon: string;
  slipType: SlipType;

  private getSlipType(slipType: string): SlipType {
    if (slipType === 'trip') return 'trip';
    if (slipType === 'consent') return 'consent';
    if (slipType === 'item') return 'item';
    return 'slip';
  }

  private getSlipIcon(slipType: string): string {
    if (slipType === 'trip') return '/assets/icon/trip-icon.svg';
    if (slipType === 'consent') return '/assets/icon/consent-icon.svg';
    if (slipType === 'item') return '/assets/icon/price-tag-icon.svg';
    return '/assets/icon/slip-icon.svg';
  }
}
